/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_Copy_LinkInputs */

const cs_property_list_copy_link = /** @type {(inputs: Property_List_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopírovat odkaz`)
};

const en_property_list_copy_link = /** @type {(inputs: Property_List_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Property_List_Copy_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_copy_link = /** @type {((inputs?: Property_List_Copy_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_Copy_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_copy_link(inputs)
	return cs_property_list_copy_link(inputs)
});